<template>
  <v-list-group>
    <template v-slot:activator>
      <v-col cols="10">
        <p class="h4 text-left mb-0">いいね! の仲間</p>
      </v-col>
    </template>
    <v-row>
      <div v-for="(item, index) in niceList" :key="index">
        <v-col cols="12" class="text-center">
          <Avatar :src="item.NICE_USER_AVATER" :size="40" class="mr-2" />
          {{ item.NICE_USER_NAME }}({{ item.NICE_USER_POSITION }})
        </v-col>
      </div>
    </v-row>
  </v-list-group>
</template>

<script>
export default {
  name: 'NiceList',

  props: {
    niceList: {
      type: Array,
      required: true,
    },
  },
};
</script>
